import { useMutation } from '@apollo/client';
import { GENERATE_POST_INSIGHT } from '../../../../graphql/resolvers/postAnalytics/generatePostInsight.gql';
import './InsightsPanel.scss';

export default function InsightsPanel({ postId }: { postId: string }) {
  const [generate, { data, loading, error }] = useMutation(
    GENERATE_POST_INSIGHT,
    {
      variables: { postId },
    },
  );
  const reading = data?.generatePostInsight?.reading;

  return (
    <div className="INSIGHT">
      {reading ? (
        <p className="INSIGHT__reading">{reading}</p>
      ) : (
        <button
          type="button"
          className="INSIGHT__cta"
          disabled={loading}
          // useMutation surfaces the failure via `error`; catch the returned
          // promise so a rejected mutation isn't an unhandled rejection.
          onClick={() => {
            void generate().catch(() => {});
          }}
        >
          {loading ? 'Reading your metrics…' : 'Generate insight'}
        </button>
      )}
      {error && !loading && (
        <p className="INSIGHT__error">
          Couldn't generate an insight — try again.
        </p>
      )}
    </div>
  );
}
